<template>
  <section class="reconditioning">
    <header>
      <h2>Reacondicionamiento</h2>
      <p class="note">Consultá los trabajos aprobados y las órdenes de servicio desde la confirmación de Caja.</p>
    </header>

    <p v-if="!confirmedFichas.length" class="note">No hay fichas con una confirmación válida de Caja.</p>
    <p v-else-if="!filteredFichas.length" class="note">No hay fichas confirmadas que coincidan con la búsqueda.</p>

    <div v-if="confirmedFichas.length" class="cards">
      <TomaReconditioningCard
        v-for="ficha in confirmedFichas"
        v-show="matchesSearch(ficha)"
        :key="ficha.id"
        :ficha="ficha"
        :session-context="sessionContext"
        :fetch-reconditioning="fetchReconditioning"
        :can-review="canReview"
        :review-job="reviewJob"
        @open="$emit('open', ficha)"
      />
    </div>
  </section>
</template>

<script>
import TomaReconditioningCard from './TomaReconditioningCard.vue'

const validPositiveDate = value => {
  if (value instanceof Date) return Number.isFinite(value.getTime()) && value.getTime() > 0
  if (typeof value === 'number') return Number.isFinite(value) && value > 0 && Number.isFinite(new Date(value).getTime())
  if (typeof value !== 'string' || !value.trim()) return false
  const text = value.trim()
  const timestamp = /^-?\d+(?:\.\d+)?$/.test(text) ? Number(text) : Date.parse(text)
  return Number.isFinite(timestamp) && timestamp > 0 && Number.isFinite(new Date(timestamp).getTime())
}

export default {
  name: 'TomaReconditioning',
  components: { TomaReconditioningCard },
  props: {
    fichas: { type: Array, default: () => [] },
    query: { type: String, default: '' },
    sessionContext: { type: String, required: true },
    fetchReconditioning: { type: Function, required: true },
    canReview: { type: Boolean, default: false },
    reviewJob: { type: Function, default: null }
  },
  computed: {
    confirmedFichas () {
      return (Array.isArray(this.fichas) ? this.fichas : []).filter(ficha => {
        const accepted = ficha && ficha.recepcion && ficha.recepcion.aceptacion && ficha.recepcion.aceptacion.fecha
        return ficha && Number.isSafeInteger(Number(ficha.id)) && Number(ficha.id) > 0 && validPositiveDate(accepted)
      })
    },
    filteredFichas () {
      return this.confirmedFichas.filter(ficha => this.matchesSearch(ficha))
    }
  },
  methods: {
    matchesSearch (ficha) {
      const query = String(this.query || '').trim().toLocaleLowerCase()
      if (!query) return true
      const vehicle = ficha && ficha.vehiculo ? ficha.vehiculo : {}
      const seller = ficha && ficha.vendedor ? ficha.vendedor : {}
      const value = [ficha && ficha.id, ficha && ficha.numero, ficha && ficha.cliente, vehicle.dominio,
        vehicle.marca, vehicle.modelo, seller.nombre].join(' ').toLocaleLowerCase()
      return value.includes(query)
    }
  }
}
</script>

<style scoped>
.reconditioning { display: grid; gap: 18px; }
.cards { display: grid; grid-template-columns: repeat(auto-fit, minmax(min(100%, 340px), 1fr)); gap: 16px; align-items: start; }
.note { color: #64748b; }
</style>
